import { isFunction } from 'utils/is';

export default function use(...plugins) {
  plugins.forEach(p => {
    isFunction(p) &&
      p({
        proto: this.prototype,
        blcktive: this.blcktive,
        instance: this
      });
  });
  return this;
}
